<template>
  <CRow>
    <CCol md="6" lg="3" v-for="(item, key) in extEnv.displayItem" :key="key">
      <CCard>
        <CCardBody class="pb-0 d-flex justify-content-between">
          <div v-if="key === 'wind'">
            {{ item.title }}
            <div class="text-value-lg" :style="'color: ' + item.color">
              <i class="fa fa-arrow-up" :style="item.style" aria-hidden="true"></i>
              {{ item.value }}{{ item.unit }}
            </div>
          </div>
          <div v-else>
            {{ item.title }}
            <div class="text-value-lg" :style="'color: ' + item.color">
              <i
                class="fa fa-arrow-circle-down"
                v-if="item.icon === 'down'"
              ></i>
              <i
                class="fa fa-arrow-circle-up"
                v-else-if="item.icon === 'up'"
              ></i>
              {{ item.value }}{{ item.unit }}
            </div>
          </div>
        </CCardBody>
        <CChartLineSimple
          class="mt-3 mx-3 mb-3"
          style="height: 40px"
          :border-color="item.color"
          :data-points="item.list"
          :options="{ elements: { line: { borderWidth: 2.5 } } }"
          :label="item.chartLabel"
        />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import store from "@/store";
import { CChartLineSimple } from "@/views/charts/index.js";

export default {
  name: "ExtEnvComponent",
  components: {
    CChartLineSimple,
  },
  data() {
    return {
      app: store.state.app,
      extEnv: {
        displayItem: {},
      },
      defaultExtDisplayItem: {
        temp: {
          title: "외기온도",
          value: "",
          icon: "",
          unit: "℃",
          list: [],
          chartLabel: "온도",
          color: "#ff6600",
        },
        humidity: {
          title: "외기습도",
          value: "",
          icon: "",
          unit: "%",
          list: [],
          chartLabel: "습도",
          color: "#1495ff",
        },
        wind: {
          title: "외기 풍향/풍속",
          value: "",
          icon: "",
          unit: "m/s",
          list: [],
          chartLabel: "풍속",
          style: "",
          color: "#458d06",
        },
        solarRadiation: {
          title: "일사량",
          value: "",
          icon: "",
          unit: "",
          list: [],
          chartLabel: "일사량",
          style: "",
          color: "#790cb1",
        },
      },
    };
  },
  created() {
    //console.log("created");
    this.getExtEnvList();
  },
  watch: {
    "app.facilityId"(val) {
      if (val != null) {
        console.log("reload extEnvList");
        this.getExtEnvList();
      }
    },
  },
  methods: {
    async getExtEnvList() {
      this.extEnv.displayItem = core.utils.deepCopy(this.defaultExtDisplayItem);

      const app = this.app;

      // 외부 온도값 조회
      const startMoment = core.date.instance();
      const endMoment = core.date.instance().add(1, "days");
      const extEnvList = (this.extEnvList = await SensorService.getExtEnvList({
        facilityId: app.facilityId,
        sensingAtGreaterThanEqual: startMoment.format("YYYY-MM-DD"),
        sensingAtLessThan: endMoment.format("YYYY-MM-DD"),
      }));
      if (extEnvList.length > 0) {
        const extEnv = extEnvList[extEnvList.length - 1];
        extEnv.displayItem = core.utils.deepCopy(this.defaultExtDisplayItem);
        for (const key of Object.keys(extEnv.displayItem)) {
          const item = extEnv.displayItem[key];
          item.value = extEnv[key];
        }

        // 마지막 20개 데이터만 처리
        let length = extEnvList.length;
        let startIndex = 0;
        if (length >= 20) {
          startIndex = length - 20;
        }

        for (let i = startIndex; i < length; i++) {
          const _extEnv = extEnvList[i];
          extEnv.displayItem.temp.list.push(_extEnv.temp);
          extEnv.displayItem.humidity.list.push(_extEnv.humidity);
          extEnv.displayItem.wind.list.push(_extEnv.windSpeed);
          extEnv.displayItem.solarRadiation.list.push(_extEnv.solarRadiation);
        }

        //console.log("extEnv : ", extEnv);
        let preExtEnv = null;
        if (extEnvList.length > 1)
          preExtEnv = extEnvList[extEnvList.length - 2];
        if (preExtEnv != null) {
          function changeIcon(key) {
            if (preExtEnv[key] < extEnv[key]) {
              extEnv.displayItem[key].icon = "up";
            } else if (preExtEnv[key] > extEnv[key]) {
              extEnv.displayItem[key].icon = "down";
            } else {
              extEnv.displayItem[key].icon = "";
            }
          }

          changeIcon("temp");
          changeIcon("humidity");
          changeIcon("solarRadiation");
        }

        const windDirection = core.utils.windDirection(extEnv.windDirection);
        extEnv.displayItem.wind.value =
          windDirection.text + " " + extEnv.windSpeed;
        extEnv.displayItem.wind.style = `transform:rotate(${extEnv.windDirection}deg);`;

        this.extEnv = extEnv;
      } else {
        this.extEnv = {};
        this.extEnv.displayItem = {}
      }
    },
  },
};
</script>
